import { FC } from "react"
import { Outlet } from "react-router-dom"

const OrganizationPage: FC = () => {
  return <Outlet />
}

export default OrganizationPage
